import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@mui/material';
import  HeaderImg  from '../../assets/images/PrispekHeader.png';
import './header.scss';
import HeaderDesktop from '../../assets/videos/Header_desktop.mp4';
import HeaderMobile from '../../assets/videos/Header_mobile.mp4';
import HeaderTablet from '../../assets/videos/Header_tablet.mp4';
import {useWindowDimensions} from "../../hooks";

export const Header: React.FC = React.memo(() => {
  const {width} = useWindowDimensions()
  const memoizedWidth = React.useMemo(() => width, [width]);
  return (
    <div className='header'>
  <img src={HeaderImg} style={{width:"100%",height:"90%",margin:"auto"}} alt='SAIPA' className='header__background'  />
        {/* {memoizedWidth > 1000 ?
          <video className='header__background' autoPlay loop muted>
              <source src={HeaderDesktop} type='video/mp4'/>
          </video>
          : memoizedWidth > 700 ?
          <video className='header__background' autoPlay loop muted>
              <source src={HeaderTablet} type='video/mp4'/>
          </video> :
          <video className='header__background' autoPlay loop muted>
              <source src={HeaderMobile} type='video/mp4'/>
          </video>
        } */}
      <div
        // className='section'
        style={{
          background: 'transparent',
          display: 'grid',
          placeContent: 'center'
        }}
      >
        <h4 className='header__slogan' >
          Wealth Creation With Integrity since 1996
        </h4>
        <div className='header__cta--group'>
          <Link to='/contact'>
            <Button
              variant='contained'
              color='primary'
              className='header__cta'
            >
              Book Appointment
            </Button>
          </Link>
          <Button
            href='#footer'
            variant='contained'
            color='secondary'
            style={{color: 'white'}}
          >
            Get in Touch
          </Button>
        </div>
      </div>
    </div>
  )
});
